export default __webpack_public_path__ + "static/media/photo--lg--33.879d1a9a.jpg";